<template>
  <v-container fluid class="container-page">
    <v-row>
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="12"
        class="d-flex text-title-container"
      >
        <div class="text-title text-primary">Users</div>
        <v-spacer></v-spacer>
        <div class="d-flex align-center">
          <div class="text-label m-r-10">
            {{ showActive ? 'Show only active users' : 'Show all users' }}
          </div>
          <v-switch
            v-model="showActive"
            inset
            dense
            x-small
            hide-details
          ></v-switch>
        </div>
        <v-btn
          id="new-user"
          class="m-auto"
          color="btn-primary"
          @click="dialog = true"
          >New</v-btn
        >
      </v-col>
    </v-row>

    <div>
      <v-data-table
        :loading="loading"
        loading-text="Loading..."
        :headers="headers"
        :items="users"
        :sort-by.sync="search.sortBy"
        :sort-desc.sync="search.sortDesc"
        :items-per-page="9999"
        hide-default-footer
        fixed-header
        must-sort
        class="elevation-1"
      >
        <template v-slot:item="props">
          <tr
            :id="`user${users.indexOf(props.item)}`"
            class="cursor-pointer"
            @click="editItem(props.item)"
          >
            <td>{{ props.item.displayname }}</td>
            <td>{{ props.item.email }}</td>
            <td>{{ props.item.role_name }}</td>
            <td>{{ props.item.is_active }}</td>
            <td>{{ props.item.last_login | datetimeFormat }}</td>
            <td class="text-right">
              <v-menu
                v-model="openItem[users.indexOf(props.item)].status"
                :absolute="true"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    :id="`action${users.indexOf(props.item)}`"
                    class="p-l-10 p-r-10"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    fa-ellipsis-v
                  </v-icon>
                </template>
                <v-list dense>
                  <v-list-item
                    v-for="(option, index) in options"
                    :key="index"
                    :disabled="!props.item.is_restrict"
                    @click="optionClick(option.title, props.item)"
                  >
                    <v-list-item-content class="text-center">
                      <v-list-item-subtitle
                        :id="`list${index}`"
                        class="font-size-body"
                        >{{ option.title }}</v-list-item-subtitle
                      >
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>

    <dialog-manage
      v-if="dialog"
      :dialog="dialog"
      :roles="roles"
      :editedIndex="editedIndex"
      :editedItem="editedItem"
      :errorMessage="errorMessage"
      :rules="rules"
      :drags="drags"
      :queues="queues"
      @close="close"
      @save="save"
    />

    <dialog-confirm v-if="dialogConfirm.open" :dialogConfirm="dialogConfirm" />

    <snackbar v-if="snackbar.open" :snackbar="snackbar" />
  </v-container>
</template>

<script>
import apiUser from '@/apis/user'
import apiRole from '@/apis/role'
import apiQueue from '@/apis/queue'
import DialogManage from './components/dialog_manage'
import Snackbar from './components/snackbar'
import DialogConfirm from './components/dialog_confirm'
import Avatar from '@/assets/guest-user.png'
export default {
  name: 'UserManagement',
  props: {
    rulesEmail: Object,
    rulesPassword: Object,
    rulesDisplayname: Object
  },
  components: {
    DialogManage,
    Snackbar,
    DialogConfirm
  },
  data() {
    return {
      loading: false,
      search: {
        sortBy: [],
        sortDesc: []
      },
      headers: [
        {
          text: 'Display name',
          align: 'start',
          sortable: true,
          value: 'displayname',
          class: 'header-alignment'
        },
        { text: 'Email', sortable: true, value: 'email' },
        { text: 'Role', sortable: true, value: 'role_name' },
        {
          text: 'Status',
          sortable: true,
          value: 'is_active',
          class: 'header-alignment'
        },
        {
          text: 'Last login',
          sortable: true,
          value: 'last_login',
          class: 'header-alignment'
        },
        { text: '', sortable: false, value: 'actions' }
      ],
      users: [],
      allUsers: [],
      roles: [],
      dialog: false,
      editedIndex: -1,
      editedItem: {
        // Profile
        avatar: Avatar,
        user_type: '',
        email: '',
        disableEmail: false,
        password: '',
        disablePassword: false,
        show_password: false,
        displayname: '',
        role_id: '',
        role_name: '',
        is_active: true,
        auth_type: 'local',
        is_restrict: false,
        disableEdit: false,
        // Queue
        setting: {
          auto_pickup: false,
          auto_pickup_capacity: 0
        },
        is_system_user: false
      },
      defaultItem: {},
      errorMessage: {
        text: ''
      },
      options: [{ title: 'Unlock user' }],
      drags: [],
      queues: [],
      openItem: [],
      dialogConfirm: {
        _id: '',
        open: false,
        option: '',
        email: ''
      },
      snackbar: {
        open: false,
        colorSnackbar: '',
        textSnackbar: ''
      },
      showActive: true
    }
  },
  created() {
    document.title = this.$t('page-title.users', {
      productName: this.$options.filters.getVariable('product_name')
    })

    this.defaultItem = _.cloneDeep(this.editedItem)

    this.initial()
  },
  watch: {
    showActive: {
      handler() {
        this.filterActive()
      }
    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'New user' : 'Edit user'
    },
    rules() {
      return {
        rulesEmail: this.rulesEmail,
        rulesPassword: this.rulesPassword,
        rulesDisplayname: this.rulesDisplayname
      }
    }
  },
  methods: {
    async initial() {
      await this.getQueue()
      await this.getRole()
      await this.hasOneAdminActive()
      await this.getUser()
    },
    async getUser() {
      try {
        this.loading = true
        this.users = []
        this.allUsers = []
        this.openItem = []
        const getUser = await apiUser.getUser()
        const { data } = getUser
        for (let i = 0; i < data.length; i++) {
          const obj = {}
          obj._id = data[i]._id ? data[i]._id : ''
          obj.email = data[i].email
          obj.role_id = data[i].enrollee_info._id
            ? data[i].enrollee_info._id
            : ''
          obj.role_name = data[i].enrollee_info.name
            ? data[i].enrollee_info.name
            : '-'
          obj.is_active = data[i].is_active
            ? data[i].is_restrict
              ? 'Active - locked out'
              : 'Active'
            : 'Inactive'
          obj.last_login = data[i].last_login
          obj.displayname = data[i].displayname
          obj.auth_type = data[i].auth_type ? data[i].auth_type : 'local'
          obj.is_system_user = data[i].is_system_user
          obj.is_restrict = data[i].is_restrict
          obj.queues_member = data[i].queues_member
          obj.auto_pickup = data[i].setting.auto_pickup
          obj.auto_pickup_capacity = data[i].setting.auto_pickup_capacity
          obj.avatar = data[i].avatar
          this.allUsers.push(obj)
          const obj1 = {}
          obj1.status = false
          this.openItem.push(obj1)
        }

        this.filterActive()

        setTimeout(() => {
          this.loading = false
        }, 500)
      } catch (error) {}
    },
    filterActive() {
      if (this.showActive) {
        this.users = _.filter(this.allUsers, o => {
          return o.is_active.includes('Active')
        })
      } else {
        this.users = [...this.allUsers]
      }
    },
    async getRole() {
      try {
        this.roles = []
        const getRole = await apiRole.getRole()
        const { data } = getRole
        for (let i = 0; i < data.length; i++) {
          const obj = {}
          obj._id = data[i]._id ? data[i]._id : ''
          obj.label = data[i].name ? data[i].name : ''
          this.roles.push(obj)
        }
      } catch (error) {}
    },
    async getQueue() {
      try {
        this.queues = []
        const getQueue = await apiQueue.getQueue()
        const { data } = getQueue
        for (let i = 0; i < data.length; i++) {
          const obj = {}
          obj.status = true
          obj._id = data[i]._id ? data[i]._id : ''
          obj.name = data[i].name ? data[i].name : ''
          obj.type = data[i].type ? data[i].type : ''
          this.queues.push(obj)
        }
      } catch (error) {}
    },
    async hasOneAdminActive() {
      try {
        const params = {
          role_name: 'admin',
          is_active: true
        }
        this.hasOneAdmin = false
        const hasOneAdminActive = await apiUser.hasOneAdminActive(params)
        if (hasOneAdminActive.data.length !== 0) {
          if (hasOneAdminActive.data[0].count === 1) {
            this.hasOneAdmin = true
          }
        } else {
          this.hasOneAdmin = true
        }
      } catch (error) {}
    },
    optionClick(option, item) {
      if (option === 'Unlock user') {
        this.dialogConfirm._id = item._id
        const obj = {
          login_attempt: 0,
          is_restrict: false
        }
        this.updateUser(this.dialogConfirm._id, obj)
        this.dialogConfirm.open = true
        this.dialogConfirm.option = 'Unlock user'
        this.dialogConfirm.email = item.email
      }
    },
    editItem(item) {
      this.editedIndex = this.users.indexOf(item)
      this.editedItem._id = item._id
      this.editedItem.avatar = item.avatar
      this.editedItem.displayname = item.displayname
      this.editedItem.email = item.email
      this.editedItem.role_id = item.role_id
      this.editedItem.role_name = item.role_name
      const isActive =
        item.is_active === 'Active' || item.is_active === 'Active - locked out'
          ? true
          : false
      this.editedItem.is_active = isActive
      this.editedItem.auth_type = item.auth_type
      this.editedItem.is_system_user = item.is_system_user
      this.editedItem.is_restrict = item.is_restrict
      this.editedItem.disableEmail = true
      this.editedItem.disablePassword = true
      this.errorMessage.text = ''
      if (item.role_name === 'admin' && this.hasOneAdmin && isActive) {
        this.editedItem.disableEdit = true
        this.errorMessage.text =
          'There must be at least one active Admin in the system'
      }
      for (let i = 0; i < this.queues.length; i++) {
        if (item.queues_member.indexOf(this.queues[i]._id) !== -1) {
          this.queues[i].status = false
          const index = item.queues_member.indexOf(this.queues[i]._id)
          const obj = {}
          obj.name = this.queues[i].name
          obj.type = this.queues[i].type
          obj.status = true
          obj.order = i
          obj._id = this.queues[i]._id
          this.drags[index] = obj
        }
      }
      this.editedItem.setting.auto_pickup = item.auto_pickup
      this.editedItem.setting.auto_pickup_capacity = item.auto_pickup_capacity
      this.dialog = true
    },
    // updateSkills(newSkills) {
    //   this.drags = newSkills
    // },
    close() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = _.cloneDeep(this.defaultItem)
        this.editedIndex = -1
      })
      // this.avatar = Avatar
      this.errorMessage.text = ''
      this.drags = []
      for (let i = 0; i < this.queues.length; i++) {
        this.queues[i].status = true
      }
      this.tab = null
      this.currentTab = 'Profile'
    },
    async save(skills) {
      try {
        this.errorMessage.text = ''

        this.drags = skills
        if (!this.editedItem.displayname) {
          this.errorMessage.text = 'Display name is required'
          return false
        } else if (
          this.editedItem.displayname.length < 1 ||
          this.editedItem.displayname.length > 50
        ) {
          this.errorMessage.text = 'Display name must be 1-50 characters'
          return false
        }
        const queues_member = []
        for (let i = 0; i < this.drags.length; i++) {
          queues_member.push(this.drags[i]._id)
        }
        if (this.editedIndex > -1) {
          const _id = this.editedItem._id
          const obj = {
            email: this.editedItem.email.trim().toLowerCase(),
            displayname: this.editedItem.displayname.trim(),
            auth_type: this.editedItem.auth_type,
            is_system_user: this.editedItem.is_system_user,
            role: this.editedItem.role_id,
            is_active: this.editedItem.is_active,
            queues_member,
            setting: this.editedItem.setting
          }
          await this.updateUser(_id, obj)

          if (this.errorMessage.text) return false

          this.snackbar.colorSnackbar = 'success'
          this.snackbar.textSnackbar = 'Changes saved'
          this.snackbar.open = true
          this.close()
        } else {
          if (!this.editedItem.email) {
            this.errorMessage.text = 'Email is required'
            return false
          } else if (
            this.editedItem.auth_type === 'local' &&
            !this.editedItem.password
          ) {
            this.errorMessage.text = 'Password is required'
            return false
          } else if (!this.editedItem.role_id) {
            this.errorMessage.text = 'Role is required'
            return false
          }
          const obj = {
            email: this.editedItem.email.trim().toLowerCase(),
            password: this.editedItem.password.trim(),
            displayname: this.editedItem.displayname.trim(),
            role: this.editedItem.role_id,
            is_active: this.editedItem.is_active,
            auth_type: this.editedItem.auth_type,
            is_system_user: this.editedItem.is_system_user,
            queues_member,
            setting: this.editedItem.setting
          }
          const user = await apiUser.createUser(obj)

          if (user.code === 0) {
            this.snackbar.colorSnackbar = 'success'
            this.snackbar.textSnackbar = `${this.editedItem.email} created`
            this.snackbar.open = true
            this.hasOneAdminActive()
            this.getUser()
            this.close()
          } else {
            this.errorMessage.text = user.message
            return false
          }
        }
      } catch (error) {
        this.errorMessage.text = error.message
      }
    },
    async updateUser(_id, obj) {
      try {
        const updateUser = await apiUser.updateUser(_id, obj)
        this.hasOneAdminActive()
        this.getUser()
      } catch (error) {
        this.errorMessage.text = error.message
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .v-data-table__wrapper {
  height: calc(100vh - 129px);
}
::v-deep th.header-alignment {
  min-width: 110px !important;
}
</style>
